import { useState } from "react";
import { useChild } from "../../contexts/ChildContext";
import { useJournalFeed } from "../../hooks/useJournalFeed";
import JournalFeed from "../../components/journal/JournalFeed";
import JournalEntryForm from "../../components/journal/JournalEntryForm";
import ShareJournalModal from "../../components/ui/ShareJournalModal";
import EmptyState from "../../components/ui/EmptyState";

const Journal = () => {
  const { selectedChild } = useChild();
  const { events, loading } = useJournalFeed(selectedChild?.id);
  const [shareOpen, setShareOpen] = useState(false);

  return (
    <div className="card h-100" id="journal">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <h5 className="card-title mb-0">📖 Baby Journal</h5>
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => setShareOpen(true)}
            style={{ borderRadius: "50px", paddingLeft: "1rem", paddingRight: "1rem" }}
          >
            🔗 Share Journal
          </button>
        </div>

        <JournalEntryForm
          childId={selectedChild?.id}
          onAdded={() => {}}
        />

        {!loading && events.length === 0 ? (
          <EmptyState
            icon="📖"
            heading="No journal entries yet"
            message="Capture your first memory — photos, moments, and milestones all in one place."
          />
        ) : (
          <JournalFeed events={events} loading={loading} />
        )}
      </div>

      <ShareJournalModal
        isOpen={shareOpen}
        onClose={() => setShareOpen(false)}
        childId={selectedChild?.id}
        childName={selectedChild?.name || "your child"}
      />
    </div>
  );
};

export default Journal;
